/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".clickable[_ngcontent-%COMP%]{cursor:pointer}.selected[_ngcontent-%COMP%]{background-color:#00a8ab}.selected[_ngcontent-%COMP%]   .text-themecolor[_ngcontent-%COMP%]{color:#fff!important;font-weight:bolder}.continue[_ngcontent-%COMP%]{padding-top:10px}"];
export { styles as styles };
